import React from "react";
import { IContent, IPMBlock } from "../../../models/IPages";
import Input from "../../../components/UI/input/GgInput";
import FormSelect from "../../../components/UI/formSelect/formSelect";
import FileButton from "../../../components/UI/button/FileButton";
import { AddIcon } from "../../../assets/icons";
import { getImageExtensionFromBase64 } from "../../../utils";

function FourthBlock({ data, setData, articles, categoryType, actionData }: IPMBlock) {
  const handleFourthBlock = (val: string, type: keyof IContent) =>
    setData((prev: any) => {
      if (type === "image") {
        const ext = getImageExtensionFromBase64(val);
        return {
          ...prev,
          [type]: `/image/page-management/${categoryType}/fourthBlock1.${
            ext || "jpeg"
          }`,
          images: [val],
        };
      }
      return { ...prev, [type]: val };
    });

  return (
    <>
      <div className="title">Single Article Block</div>
      <div className="step-list">
        <div className="step-list col">
          <div className="step-item">
            <div className="inputs-container">
              <Input
                type="text"
                placeholder="Enter title"
                value={data?.heading}
                onChange={(val) => handleFourthBlock(val, "heading")}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          <div className="step-item">
            <div className="inputs-container">
              <Input
                type="text"
                placeholder="Enter Description"
                value={data?.description}
                onChange={(val) => handleFourthBlock(val, "description")}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          <div className="step-item">
            <Input
              type="text"
              placeholder="Enter link"
              value={data?.link}
              onChange={(val) => handleFourthBlock(val, "link")}
              disabled={!actionData?.edit}
            />
            {/* <FormSelect
              list={articles}
              defaultValue={data?.link}
              label="Page link"
              onChange={(val) => handleFourthBlock(val.value, "link")}
            /> */}
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <FileButton
            index={"refinance-fourth"}
            icon={{
              leftIcon: <AddIcon size="18" className="icon" />,
            }}
            value={data?.image}
            stylesType="border"
            onChange={(val) => handleFourthBlock(val, "image")}
            className="cover-image-button"
            disabled={!actionData?.edit}
          />
        </div>
      </div>
    </>
  );
}

export default FourthBlock;
